import { useEffect } from 'react'

import { cn } from '@/lib/utils'

import { useCaseActionHistoryDrawerStore } from '../../store'
import { ActionCompletedAccordion } from './ui/action-completed-accordion/action-completed-accordion'
import { ActionCompletedFilters } from './ui/action-completed-filters/action-completed-filters'

export const DashboardTaskManagementActionCompletedPage = () => {
  const { close: closeCaseActionHistoryDrawer } = useCaseActionHistoryDrawerStore()

  useEffect(() => {
    return () => {
      closeCaseActionHistoryDrawer()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={cn('mt-6')}>
      <ActionCompletedFilters />

      <div className={cn('mt-5')}>
        <ActionCompletedAccordion />
      </div>
    </div>
  )
}
